export default __webpack_public_path__ + "static/icon-dropdown-news-ffb40875ff2c78bb1db0bf85d5dda8ca.svg";